<div class="domain-import-progress">
    <!-- Progress Header -->
    <div class="progress-header mb-4">
        <div class="row align-items-center">
            <div class="col-md-32">
                <h5 translate>Importing Domains</h5>
                <p class="text-muted mb-0" translate>
                    Please wait while we create your domains. This process may take a few minutes.
                </p>
            </div>
            <div class="col-md-16 text-end">
                <div class="progress-stats">
                    <div class="stat-item">
                        <div class="stat-numbers">
                            <span class="stat-number">{{ progress?.current || 0 }}</span>
                            <span class="stat-divider">/</span>
                            <span class="stat-total">{{ progress?.total || 0 }}</span>
                        </div>
                        <div class="stat-label" translate>Domains</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Progress Bar -->
    <div class="main-progress mb-4">
        <div class="progress-container">
            <div class="progress progress-lg">
                <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    [class]="getProgressBarColor()"
                    role="progressbar"
                    [style.width.%]="animatedProgress"
                    [attr.aria-valuenow]="progress?.current || 0"
                    [attr.aria-valuemin]="0"
                    [attr.aria-valuemax]="progress?.total || 0">
                </div>
            </div>
            <div class="progress-percentage">
                {{ getProgressPercentage().toFixed(1) }}%
            </div>
        </div>
    </div>

    <!-- Current Domain Info -->
    <div class="current-domain mb-4" *ngIf="progress?.currentDomain">
        <div class="current-domain-card">
            <div class="current-domain-icon">
                <i class="fas fa-globe spinning"></i>
            </div>
            <div class="current-domain-info">
                <h6 class="current-domain-title" translate>Currently Processing</h6>
                <p class="current-domain-name">{{ progress.currentDomain }}</p>
            </div>
        </div>
    </div>

    <!-- Status Message -->
    <div class="status-message mb-4">
        <div class="alert" [class.alert-info]="!isCompleted()" [class.alert-success]="isCompleted()">
            <i class="fas" [class.fa-cog]="!isCompleted()" [class.fa-spin]="!isCompleted()" [class.fa-check-circle]="isCompleted()"></i>
            <span class="ms-2">{{ getCompletionMessage() }}</span>
        </div>
    </div>

    <!-- Progress Statistics -->
    <div class="progress-statistics">
        <div class="row">
            <div class="col-md-11 col-24">
                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="fas fa-clock"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-value">{{ formatTime(getElapsedTime()) }}</div>
                        <div class="stat-label" translate>Elapsed</div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-11 col-24" *ngIf="!isCompleted()">
                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="fas fa-hourglass-half"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-value">{{ formatTime(estimatedTimeRemaining) }}</div>
                        <div class="stat-label" translate>Remaining</div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-11 col-24">
                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="fas fa-tachometer-alt"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-value">{{ formatRate(domainsPerSecond) }}</div>
                        <div class="stat-label" translate>Rate</div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-11 col-24">
                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="fas fa-list-ol"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-value">{{ (progress?.total || 0) - (progress?.current || 0) }}</div>
                        <div class="stat-label" translate>Remaining</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Completion Actions -->
    <div class="completion-actions text-center mt-4" *ngIf="isCompleted()">
        <div class="completion-icon mb-3">
            <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
        </div>
        <h5 class="text-success" translate>Import Completed Successfully!</h5>
        <p class="text-muted" translate>
            All domains have been imported. Click "View Results" to see the detailed report.
        </p>
    </div>
</div>

